import React from "react";
import { useSelector } from "react-redux";
import messages from "utils/messages";
import constants from "common/constants";
import { subDays, format } from "date-fns";
import Slider from "rc-slider";

const BoardFooter = (props) => {
  const controlPanel = useSelector((state) => state.controlPanel);
  const habitsDates = useSelector((state) => {
    if (state.boardFilter?.groupId) {
      const dates = [];
      for (const habit of Object.values(state.habitsEntities)) {
        if (habit.group_id === state.boardFilter.groupId) {
          dates.push(state.dates[habit.id]);
        }
      }
      return dates;
    } else return Object.values(state.dates);
  });
  const handleChange = (e) => {
    props.showStats(e);
  };

  const handleNewHabit = () => {
    if (!props.user.isPremium && props.numHabits >= 3)
      props.showPremiumFeatureModal();
    else props.showNewHabitModal();
  };

  const renderRow = () => {
    const row = [];

    // if (!habitsDates[0]) return null;

    let numDaysView = props.numDaysView;
    let offset = props.offset;
    if (constants.numDays - numDaysView + 1 === offset) {
      offset++;
      numDaysView--;
    }

    for (let i = 1; i <= numDaysView; i++, offset++) {
      let sum = 0;
      for (let j = 0; j < habitsDates.length; j++) {
        const habitDateObj = habitsDates[j];
        if (!habitDateObj) continue;
        const habitDate =
          habitDateObj[
            format(
              subDays(props.currentDay, constants.numDays - offset),
              "YYYY-MM-DD"
            )
          ];
        if (habitDate && habitDate.isMarked) {
          sum++;
        }
      }
      if (offset === constants.numDays) {
        row.push(
          <td key={i} className="today">
            {sum}
          </td>
        );
      } else row.push(<td key={i}>{sum}</td>);
    }

    return <tr>{row}</tr>;
  };

  const { hideNewHabit } = props;

  return (
    <div className="boardfooter">
      {controlPanel.isVisible ? (
        <div className="controlpanel-footer"></div>
      ) : null}
      {hideNewHabit ? (
        <div className="newhabit" />
      ) : (
        <div className="newhabit newhabit-hover" onClick={handleNewHabit}>
          <i className="ion-plus" /> {messages.NEW_HABIT}
        </div>
      )}
      <div className="counts">
        <table>
          <tbody>{renderRow()}</tbody>
        </table>
      </div>
      <div className="stats-slider">
        <div className="slider-wrapper">
          <Slider min={1} max={3} defaultValue={1} onChange={handleChange} />
        </div>
      </div>
    </div>
  );
};

export default BoardFooter;
